import NORTH_EXT_1 from "./NORTH_EXT_1";
export default {
  NORTH_EXT_1,
};
